module.exports = __webpack_public_path__ + "img/chevron-right.9192c70b.svg";